<nav class="sidebar sidebar-wrapper" id="">
    <div class="d-flex justify-content-center">
            <img class="logo-image" src="assets/grt.svg">
    </div>
    <ul class="list-group"  *ngIf="!isAdmin" >
        
        <li class="list-group-item" [routerLink]="['dashboard']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>DASHBOARD</li> 
        <div data-toggle="collapse" data-target="#collapseInstoreDux" aria-expanded="false" aria-controls="collapseInstoreDux">
              <li class="list-group-item" [routerLink]="['instorelist']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>INSTORE</li> 
        </div>
        <!-- <div class="collapse ml-4" id="collapseInstoreDux">
            <li class="list-group-item"[routerLink]="['addinstore']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>ADD INSTORE</li> 
            <li class="list-group-item" [routerLink]="['bulkupload']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>BULK UPLOAD</li> 
        </div> -->
        <div data-toggle="collapse" data-target="#collapseHoarding" aria-expanded="false" aria-controls="collapseHoarding">
            <li class="list-group-item"[routerLink]="['hoardinglist']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>HOARDING</li>   
        </div>
     
        <!-- <div class="collapse ml-4" id="collapseHoarding"> 
            <li class="list-group-item" [routerLink]="['addhoarding']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>ADD HOARDING</li> 
            <li class="list-group-item" [routerLink]="['bulkhoarding']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>BULK UPLOAD</li>   
        </div> -->

        <!-- <li class="list-group-item" [routerLink]="['report']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>REPORTS</li> -->
        <li class="list-group-logout"   routerLinkActive="router-link-active" (click)="openModal()">LOGOUT</li>
    </ul>

    <ul class="list-group"  *ngIf="isAdmin"  >
        
        <li class="list-group-item" [routerLink]="['dashboard']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>DASHBOARD</li> 
        <div data-toggle="collapse" data-target="#collapseInstoreDux" aria-expanded="false" aria-controls="collapseInstoreDux">
              <li class="list-group-item" [routerLink]="['instorelist']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>INSTORE</li> 
        </div>
        <div class="collapse ml-4" id="collapseInstoreDux" *ngIf="!isAdmin_only_view">
            <li class="list-group-item"[routerLink]="['addinstore']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>ADD INSTORE</li> 
            <li class="list-group-item" [routerLink]="['bulkupload']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>BULK UPLOAD</li> 
        </div>
        <div data-toggle="collapse" data-target="#collapseHoarding" aria-expanded="false" aria-controls="collapseHoarding">
            <li class="list-group-item"[routerLink]="['hoardinglist']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>HOARDING</li>   
        </div>
     
        <div class="collapse ml-4" id="collapseHoarding" *ngIf="!isAdmin_only_view"> 
            <li class="list-group-item" [routerLink]="['addhoarding']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>ADD HOARDING</li> 
            <li class="list-group-item" [routerLink]="['bulkhoarding']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>BULK UPLOAD</li>   
        </div>

        <li  *ngIf="!isAdmin_only_view" class="list-group-item" [routerLink]="['report']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>REPORTS</li> 
        <li *ngIf="!isAdmin_only_view" class="list-group-item" [routerLink]="['usermanagement']"  routerLinkActive="router-link-active"><span class="mr-2">&#9673;</span>ADMIN</li>
        <li class="list-group-logout"   routerLinkActive="router-link-active" (click)="openModal()">LOGOUT</li>
    </ul>
</nav>
